import Box from '@mui/material/Box';

const Spacer: React.FC<{ width?: string; height?: string }> = ({
  width,
  height,
}) => <Box sx={{ height: height, width: width }} />;

export default Spacer;
